import { document } from '@mtsbank/ui-kit'
import { authHelper } from '@entities/user'
import { getPreviousRoute } from '@shared/lib/next'
import {
  actionGroups,
  buttonLocations,
  eventActions,
  eventCategories,
  eventContents,
  eventContexts,
  eventLabels,
  events,
  sendGmtEvent,
  touchPoints,
} from '../baseFunctions'
import { translit } from '../translit'

// Показ главной страницы
export const mainLoadedCyberGtm = () =>
  sendGmtEvent({
    event: events.mtsPageview,
    screenName: document.location.pathname,
    eventLabel: eventLabels.glavnaya,
    actionGroup: actionGroups.nonInteractions,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.screenShow,
    ref: getPreviousRoute(),
  })

// Показ страницы pay-qr
export const payQrLoadedCyberGtm = () =>
  sendGmtEvent({
    event: events.mtsPageview,
    screenName: document.location.pathname,
    eventLabel: eventLabels.payQr,
    actionGroup: actionGroups.nonInteractions,
    eventCategory: eventCategories.igrovaya_stranica,
    ref: getPreviousRoute(),
  })

// Показ страницы rozygrysh-prizov-pubg-mobile
export const pubgGiveawayLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.rozygryshPubgMobile,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
  })

// Показ страницы rasprodaja-i-novogodniy-rozygrysh-prizov
export const newYearGiveawayLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.rasprodajaINovogodniyRozygryshPrizov,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
  })

// Показ страницы rasprodaja-i-novogodniy-rozygrysh-prizov-itogi
export const newYearGiveawayResultsLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.rasprodajaINovogodniyRozygryshPrizovItogi,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
  })

// Показ страницы rozygrysh-prizov-pubg-mobile-itogi
export const pubgGiveawayResultsLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.rozygryshPubgMobileItogi,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
  })

// Показ страницы rozygrysh-prizov-genshin-pubg-itogi
export const genshinPubgGiveawayResultsCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.rozygryshPrizovGenshinPubgItogi,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
  })

// Показ страницы pragmata-rozygrysh
export const pragmataRozygryshLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.pragmataRozygrysh,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
  })

// Показ страницы heroes-of-might-and-magic-promo
export const heroesOfMightAndMagicPromoLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.heroesOfMightAndMagicPromo,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
  })

// Показ страницы forza-horizon-promo
export const forzaHorizonPromoLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.forzaHorizonPromo,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
  })

// Показ страницы pragmata-rozygrysh-itogi
export const pragmataRozygryshItogiLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.pragmataRozygryshItogi,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
  })

// Показ страницы forza-horizon-rozygrysh-itogi
export const forzaHorizonRozygryshItogiLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.forzaHorizonRozygryshItogi,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
  })

// Клик по кнопке Купить Pragmata
export const buyPragmataClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.kupit_pragmata,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Клик по кнопке Купить ключ heroes-of-might-and-magic
export const buyHeroesKeyClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.kupitKluch,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Клик по кнопке Купить ключ forza-horizon-6
export const buyForzaHozironKeyClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.kupitKluch,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Клик по кнопке Пополнить steam
export const replenishSteamClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.replenishSteam,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Показ страницы osennii-rozygrysh-prizov-2026
export const osenniiRozygryshPrizov2026LoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.osenniiRozygryshPrizov2026,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Показ страницы osennii-rozygrysh-prizov-2026-itogi
export const osenniiRozygryshPrizov2026ItogiLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.osenniiRozygryshPrizov2026Itogi,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Показ страницы dvoinoi-shans-na-pobedu
export const dvoinoiShansNaPobeduLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.dvoinoiShansNaPobedu,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Показ страницы dvoinoi-shans-na-pobedu-itogi
export const dvoinoiShansNaPobeduItogiLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.dvoinoiShansNaPobeduItogi,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Показ страницы vesennii-rozygrysh-prizov-2026
export const vesenniiRozygrysh2026LoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.vesenniiRozygrysh2026,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Показ страницы vesennii-rozygrysh-prizov-2026-itogi
export const vesenniiRozygrysh2026ItogiLoadedCyberGtm = () =>
  sendGmtEvent({
    actionGroup: actionGroups.nonInteractions,
    event: events.mtsPageview,
    eventAction: eventActions.screenShow,
    eventCategory: eventCategories.igrovaya_stranica,
    eventLabel: eventLabels.vesenniiRozygrysh2026Itogi,
    ref: getPreviousRoute(),
    screenName: document.location.pathname,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Принять участие в весеннем розыгрыше
export const prinyatUchastieVesenniiRozygryshClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.hochuUchastvovat,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Принять участие в летнем розыгрыше
export const prinyatUchastieLetniiRozygryshClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.hochuUchastvovat,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Принять участие в осеннем розыгрыше
export const prinyatUchastieOsenniiRozygryshClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventContent: eventContents.osenniiRozygryshPrizov2026,
    eventLabel: eventLabels.hochuUchastvovat,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Регистрация в весеннем розыгрыше
export const registerVesenniiRozygryshClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.registracia,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Регистрация в летнем розыгрыше
export const registerLetniiRozygryshClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventContent: eventContents.dvoinoiShansNaPobedu,
    eventLabel: eventLabels.registracia,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Регистрация в осеннем розыгрыше
export const registerOsenniiRozygryshClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventContent: eventContents.osenniiRozygryshPrizov2026,
    eventLabel: eventLabels.registracia,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Клик по виджету весеннего розыгрыша
export const vesenniiRozygryshWidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.widgetVesenniiRozygryshPrizov2026Click,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Клик по виджету pragmata
export const pragmataRozygryshWidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.pragmataRozygrysh,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Клик по виджету forza horizon primo
export const forzaHorizonWidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.forzaHorizonPromo,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Клик по виджету app store
export const appStoreWidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.popolnyaiteAppStoreBezKomissii,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Клик по виджету зарубежной карты
export const foreignCardWidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.zarubezhnayaKarta,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Клик по виджету летнего розыгрыша
export const lentiiRozygryshWidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.letniiRozygryshSteam,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Клик по виджету осеннего розыгрыша
export const osenniiRozygryshWidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventContents.osenniiRozygryshPrizov2026,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Клик по виджету осеннего розыгрыша итоги
export const osenniiRozygryshResultsWidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.osenniiRozygryshPrizov2026Itogi,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Клик по виджету trove of terror
export const troveOfTerrorWidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.troveOfTerrorDota2,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

export const dvoinoiShansNaPobeduBannerClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventContent: eventContents.dvoinoiShansNaPobedu,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.uchastvovat,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

export const osenniiRozygryshPrizov2026BannerClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventContent: eventContents.osenniiRozygryshPrizov2026,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.uchastvovat,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Успешная регистрация в розыгрыше
export const vesenniiRozygryshTakePartSuccessGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventLabel: eventLabels.uspeshnayaRegistracia,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Ошибка регистрации в розыгрыше
export const vesenniiRozygryshTakePartErrorGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementShow,
    eventLabel: eventLabels.oshibkaRegistracii,
    screenName: document.location.pathname,
    eventContent: eventContents.vesenniiRozygryshPrizov2026,
    actionGroup: actionGroups.nonInteractions,
    touchPoint: touchPoints.web,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Успешная регистрация в розыгрыше
export const letniiRozygryshTakePartSuccessGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventContent: eventContents.dvoinoiShansNaPobedu,
    eventLabel: eventLabels.uspeshnayaRegistracia,
    screenName: document.location.pathname,
    actionGroup: actionGroups.nonInteractions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Ошибка регистрации в розыгрыше
export const letniiRozygryshTakePartErrorGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementShow,
    eventLabel: eventLabels.oshibkaRegistracii,
    screenName: document.location.pathname,
    eventContent: eventContents.dvoinoiShansNaPobedu,
    actionGroup: actionGroups.nonInteractions,
    touchPoint: touchPoints.web,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Успешная регистрация в осеннем розыгрыше
export const osenniiRozygryshTakePartSuccessGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventContent: eventContents.osenniiRozygryshPrizov2026,
    eventLabel: eventLabels.uspeshnayaRegistracia,
    screenName: document.location.pathname,
    actionGroup: actionGroups.nonInteractions,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Ошибка регистрации в осеннем розыгрыше
export const osenniiRozygryshTakePartErrorGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementShow,
    eventLabel: eventLabels.oshibkaRegistracii,
    screenName: document.location.pathname,
    eventContent: eventContents.osenniiRozygryshPrizov2026,
    actionGroup: actionGroups.nonInteractions,
    touchPoint: touchPoints.web,
    ref: getPreviousRoute(),
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })

// Показ страницы новостей
export const newsCyberGtm = (providerName: string) =>
  sendGmtEvent({
    event: events.mtsPageview,
    screenName: document.location.pathname,
    eventAction: eventActions.screenShow,
    eventLabel: eventLabels.news,
    actionGroup: actionGroups.nonInteractions,
    eventCategory: eventCategories.igrovaya_stranica,
    productName: providerName,
    ref: getPreviousRoute(),
  })

// Показ страницы сервис недоступен
export const mainErrorCyberGtm = () =>
  sendGmtEvent({
    event: events.mtsPageview,
    screenName: document.location.pathname,
    eventLabel: eventLabels.glavnayaError,
    actionGroup: actionGroups.nonInteractions,
    eventCategory: eventCategories.igrovaya_stranica,
    ref: getPreviousRoute(),
  })

// Показ финального экрана
export const resultPageCyberGtm = () =>
  sendGmtEvent({
    event: events.mtsPageview,
    screenName: document.location.pathname.split('/').slice(0, -1).join('/'),
    eventLabel: eventLabels.final,
    actionGroup: actionGroups.nonInteractions,
    eventCategory: eventCategories.igrovaya_stranica,
    ref: getPreviousRoute(),
  })

// Показ страницы сервиса
export const servicesLoadedCyberGtm = (providerName: string) =>
  sendGmtEvent({
    event: events.mtsPageview,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.screenShow,
    eventLabel: eventLabels.rekvizity,
    screenName: document.location.pathname,
    actionGroup: actionGroups.nonInteractions,
    productName: translit(providerName),
    ref: getPreviousRoute(),
  })

// Клик по виджету нг розыгрыша
export const newYearGiveawayWidgetClick = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.widgetRasprodajaINovogodniyRozygryshPrizovClick,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик по виджету итогов нг розыгрыша
export const newYearGiveawayResultsWidgetClick = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.widgetRasprodajaINovogodniyRozygryshPrizovItogiClick,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик по баннеру мтсд на странице сервиса
export const mtsdBannerClick = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.mtsdBannerClick,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик по баннеру скиллбокса (профессии в IT) на странице стима
export const skillboxBannerClick = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.bannerRekvizity,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: 'skillbox',
    ref: getPreviousRoute(),
  })

// Показ баннера скиллбокса (профессии в IT) на странице стима
export const skillboxBannerShow = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementShow,
    eventLabel: eventLabels.bannerRekvizity,
    screenName: document.location.pathname,
    actionGroup: actionGroups.nonInteractions,
    productName: 'skillbox',
    ref: getPreviousRoute(),
  })

// Клик по баннеру скиллбокса (нейросети для контента) на странице стима
export const skillbox2BannerClick = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.bannerRekvizity,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: 'skillbox_neiroseti_dlya_kontenta',
    ref: getPreviousRoute(),
  })

// Показ баннера скиллбокса (нейросети для контента) на странице стима
export const skillbox2BannerShow = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementShow,
    eventLabel: eventLabels.bannerRekvizity,
    screenName: document.location.pathname,
    actionGroup: actionGroups.nonInteractions,
    productName: 'skillbox_neiroseti_dlya_kontenta',
    ref: getPreviousRoute(),
  })

// Клик по баннеру Forza Horizon 6 на странице сервиса
export const forzaBannerClick = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.forzaHorizonPromo,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик по баннеру в слайдере на главной странице
export const sliderMainClickGtm = (slideName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.bannerMain,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: slideName,
    ref: getPreviousRoute(),
  })

// Показ баннера в слайдере на главной странице
export const sliderMainShowGtm = (slideName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementShow,
    eventLabel: eventLabels.bannerMain,
    screenName: document.location.pathname,
    actionGroup: actionGroups.nonInteractions,
    productName: slideName,
    ref: getPreviousRoute(),
  })

// Показ баннера скиллбокса на главной
export const sliderSkillboxShowGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementShow,
    eventLabel: eventLabels.bannerMain,
    screenName: document.location.pathname,
    actionGroup: actionGroups.nonInteractions,
    productName: 'skillbox',
    ref: getPreviousRoute(),
  })

// Показ баннера скиллбокса на главной
export const sliderSkillbox2ShowGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementShow,
    eventLabel: eventLabels.bannerMain,
    screenName: document.location.pathname,
    actionGroup: actionGroups.nonInteractions,
    productName: 'skillbox_neiroseti_dlya_kontenta',
    ref: getPreviousRoute(),
  })

// Клик по баннеру на финальной странице
export const bannerResultClickGtm = (bannerName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.bannerFinal,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: bannerName,
    ref: getPreviousRoute(),
  })

// Ввод в поиске
export const searchChangeGtm = (search: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.searchFormAdd,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: search,
    ref: getPreviousRoute(),
  })

// Клик по сервису из поиска
export const serviceSearchClickGtm = (providerName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.serviceSearchForm,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(providerName),
    ref: getPreviousRoute(),
  })

// Клик по сервису из популярного
export const serviceTopClickGtm = (providerName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.servicePopular,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(providerName),
    ref: getPreviousRoute(),
  })

// Клик по сервису из категории пополнения игр
export const serviceClickGtm = (providerName: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.serviceCatalog,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(providerName),
    ref: getPreviousRoute(),
  })

// Клик по табам
export const tabClickGtm = (title: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.categoryChange,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: title,
    ref: getPreviousRoute(),
  })

// Клик по новостям
export const newsClickGtm = (title: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.newsClick,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: title,
    ref: getPreviousRoute(),
  })

// Клик на ваучер\аккаунт
export const voucherAccountClickGtm = (nameButton: string) =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: translit(nameButton),
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на Принять участие в нг розыгрыше
export const takeNewYearGiveawayParticipationClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.prinyatUchastieVRasprodajaINovogodniyRozygryshPrizovClick,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
  })
}

// Клик на Пополнить стим из нг розыгрыша
export const replenishSteamFromNewYearGiveawayClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.popolnitSteamRasprodajaINovogodniyRozygryshPrizovClick,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
  })
}

// Клик на Пополнить стим из летнего розыгрыша
export const replenishSteamFromDvoinoiShansNaPobeduClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.popolnitSteam,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
  })
}

// Клик на Пополнить стим из осеннего розыгрыша
export const replenishSteamFromOsenniiRozygryshClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventContent: eventContents.osenniiRozygryshPrizov2026,
    eventLabel: eventLabels.popolnitSteam,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
    userAuth: authHelper.isAuthenticated() ? '1' : '0',
    pageType: 'cyber',
  })
}

// Ввод номера в нг розыгрыше
export const phoneNumberEnterNewYearGiveawayClickGtm = () => {
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.vvodNomeraRasprodajaINovogodniyRozygryshPrizov,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    touchPoint: touchPoints.web,
  })
}

// Передача поля login и email
export const loginOrEmailGtm = (nameService: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.login,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Передача поля login и email
export const loginOrEmailErrorGtm = (nameService: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.loginMailError,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Передача поля sum
export const sumGtm = (nameService: string, sum: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.sum,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    CD1: sum,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Клик на выбранный регион
export const countryClickGtm = (nameService: string, country: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.region,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    CD1: country,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Клик на выбранный ваучер
export const voucherSumClickGtm = (nameService: string, sum: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.clickNaVaucher,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    CD1: sum,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Клик на кнопку купить за
export const payClickGtm = (nameService: string, id: string, amount: string, paymentMethod: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.kupit,
    eventContext: paymentMethod === 'SBP' ? eventContexts.SBP : eventContexts.MTS,
    eventValue: amount,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    filterName: id,
    productName: translit(nameService),
    ref: getPreviousRoute(),
    CD1: 'uspeh',
  })

// Клик на кнопку оформить карту
export const issueACardClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.oformitKartu,
    eventContent: eventContents.osnovnayaStranica,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку оформить карту на экране успеха СБП
export const issueACardSBPClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.oformitKartu,
    eventContent: eventContents.uspehSBP,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Передача поля номер карты
// export const cardNumberGtm = () =>
//   sendGmtEvent({
//     event: events.mtsPaymentSpa,
//     eventCategory: eventCategories.igrovaya_stranica,
//     eventAction: eventActions.formAdd,
//     eventLabel: eventLabels.nomerKarty,
//     screenName: document.location.pathname,
//     actionGroup: actionGroups.interactions,
//   })

// Передача поля срок действия карты
// export const cardDateGtm = () =>
//   sendGmtEvent({
//     event: events.mtsPaymentSpa,
//     eventCategory: eventCategories.igrovaya_stranica,
//     eventAction: eventActions.formAdd,
//     eventLabel: eventLabels.srokDeistviyaKarty,
//     screenName: document.location.pathname,
//     actionGroup: actionGroups.interactions,
//   })

// Передача поля код карты
// export const cardCvcGtm = () =>
//   sendGmtEvent({
//     event: events.mtsPaymentSpa,
//     eventCategory: eventCategories.igrovaya_stranica,
//     eventAction: eventActions.formAdd,
//     eventLabel: eventLabels.kodKarty,
//     screenName: document.location.pathname,
//     actionGroup: actionGroups.interactions,
//   })

// Клик на кнопку оплатить
// export const paymentClickGtm = () =>
//   sendGmtEvent({
//     event: events.mtsPaymentSpa,
//     eventCategory: eventCategories.igrovaya_stranica,
//     eventAction: eventActions.buttonClick,
//     eventLabel: eventLabels.oplatit,
//     eventContext: eventContexts.cardMTS,
//     screenName: document.location.pathname,
//     actionGroup: actionGroups.interactions,
//   })

// Экран успешной оплаты
export const sucssesOplataGtm = (nameService: string, id: string, sbp?: boolean) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventLabel: eventLabels.platezhOtpravlen,
    eventContext: sbp ? eventContexts.SBP : eventContexts.MTS,
    screenName: document.location.pathname.split('/').slice(0, -1).join('/'),
    actionGroup: actionGroups.conversions,
    filterName: id,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Экран обработки платежа
export const waitedOplataGtm = (nameService: string, id: string, sbp?: boolean) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventLabel: eventLabels.platezhVobrabotke,
    eventContext: sbp ? eventContexts.SBP : eventContexts.MTS,
    screenName: document.location.pathname.split('/').slice(0, -1).join('/'),
    actionGroup: actionGroups.conversions,
    filterName: id,
    productName: translit(nameService),
    ref: getPreviousRoute(),
  })

// Экран неуспеха
export const rejectedOplataGtm = (id: string, sbp?: boolean) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formRejected,
    eventLabel: eventLabels.platezhNeOtpravlen,
    eventContext: sbp ? eventContexts.SBP : eventContexts.MTS,
    screenName: document.location.pathname.split('/').slice(0, -1).join('/'),
    actionGroup: actionGroups.conversions,
    filterName: id,
    ref: getPreviousRoute(),
  })

// Экран успешной оплаты мтс карта
export const sucssesMTSCardGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventLabel: eventLabels.platezhOtpravlen,
    eventContext: eventContexts.cardMTS,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Экран неуспешной оплаты мтс карта
export const rejectedMTSCardGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formRejected,
    eventLabel: eventLabels.platezhNeOtpravlen,
    eventContext: eventContexts.cardMTS,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Экран недостаточно средств мтс карта
export const noMoneyMTSCardGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formRejected,
    eventLabel: eventLabels.nedostatochnoSredstv,
    eventContext: eventContexts.cardMTS,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Клик по сервису
export const bannerClickGtm = () =>
  sendGmtEvent({
    event: events.mtsSpaCyber,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.podrobnee,
    eventContext: eventContexts.nachniIgru,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на главную
export const homeClickGtm = (nameService?: string) =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.toMainPage,
    screenName: document.location.pathname.split('/').slice(0, -1).join('/'),
    actionGroup: actionGroups.interactions,
    productName: translit(nameService as string),
    ref: getPreviousRoute(),
  })

// Клик на кнопку принять участие
export const promoButtonClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.prinyatUchastie,
    eventContext: eventContexts.promoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Заполение телефона
export const phoneGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.nomerTelefona,
    eventContext: eventContexts.promoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    // productName: translit(nameService),
    // em: loginOrEmail,
    ref: getPreviousRoute(),
  })

// Экран успешной регистрации
export const sucssesPromoRegGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formConfirm,
    eventLabel: eventLabels.uchastnikRozigrisha,
    eventContext: eventContexts.promoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку пополнить акк на промо странице
export const payAccClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.popolnitAkkaunt,
    eventContext: eventContexts.promoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку пополнить акк в модалке
export const payAccPopUpClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.popolnitAkkaunt,
    eventContext: eventContexts.popUpPromoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Показ формы заполения телефона
export const phoneFormShowGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.formShow,
    eventLabel: eventLabels.promoInarius,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку Оформить в шапке
export const designButtonHeaderClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.oformitKartu,
    productName: 'mts_cashback_lite_mir',
    productId: 'vc_cashback_lite_mir',
    buttonLocation: buttonLocations.header,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку Оформить в футоре
export const designButtonFooterClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.buttonClick,
    eventLabel: eventLabels.oformitKartu,
    productName: 'mts_cashback_lite_mir',
    productId: 'vc_cashback_lite_mir',
    buttonLocation: buttonLocations.footer,
    screenName: document.location.pathname,
    actionGroup: actionGroups.conversions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку Оформить в футоре
export const FullTermsClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.pravilaAkciiKeshbekZaIgry,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на виджет
export const WidgetClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.vidzhetKeshbek30,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на кнопку индивидуального заказа
export const individualOrderClickGtm = () =>
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.bannerClick,
    eventLabel: eventLabels.individZakaz,
    screenName: document.location.pathname,
    actionGroup: actionGroups.interactions,
    ref: getPreviousRoute(),
  })

// Клик на способ оплаты СБП
export const sbpPaymentMethodClickGtm = (providerName: string) => {
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.sbp,
    screenName: document.location.pathname,
    eventContext: eventContexts.vyberiteSposobOplaty,
    actionGroup: actionGroups.interactions,
    productName: providerName,
    touchPoint: touchPoints.web,
  })
}

// Клик на способ оплаты счет МТС
export const mtsPaymentMethodClickGtm = (providerName: string) => {
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.schetMts,
    screenName: document.location.pathname,
    eventContext: eventContexts.vyberiteSposobOplaty,
    actionGroup: actionGroups.interactions,
    productName: providerName,
    touchPoint: touchPoints.web,
  })
}

// Клик на способ оплаты банковская карта
export const cardPaymentMethodClickGtm = (providerName: string) => {
  sendGmtEvent({
    event: events.mtsPaymentSpa,
    eventCategory: eventCategories.igrovaya_stranica,
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.bankovskayaKarta,
    screenName: document.location.pathname,
    eventContext: eventContexts.vyberiteSposobOplaty,
    actionGroup: actionGroups.interactions,
    productName: providerName,
    touchPoint: touchPoints.web,
  })
}
